import * as tslib_1 from "tslib";
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { getOptionsForFeature, lazyCreateOrUpdateOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
    userOptions: function () {
        return getOptionsForFeature(OwsOptionsFeatureType.SmartSuggestions);
    },
})(action('saveQuickSuggestionOption')(function saveQuickSuggestionOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    userOptions.smartSuggestionsEnabled = getFallbackValueIfNull(optionState.smartSuggestionsEnabled, userOptions.smartSuggestionsEnabled);
                    userOptions.browserLocationEnabled = getFallbackValueIfNull(optionState.browserLocationEnabled, userOptions.browserLocationEnabled);
                    return [4 /*yield*/, lazyCreateOrUpdateOptionsForFeature.importAndExecute(OwsOptionsFeatureType.SmartSuggestions, userOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveQuickSuggestionOption.js.map